import { Button } from "@material-ui/core";
import { useState } from 'react';
import { useSelector } from "react-redux";
import { selectIsClient } from "features/user/userSlice";
import { IconAdd } from "../../../icons";
import CreateWorkOrderPage from "features/landing/components/WorkorderDashboard/CreateWorkOrder/CreateWorkOrderPage";
import AddActivityDialog from "./AddActivityDialog";

const AddActivity = ({ vehicleId, lotId, clientId, onClose, vehicleTypeId, entityId, vehicleDetails }) => {
    const [open, setOpen] = useState(false);
    const isClient = useSelector(selectIsClient);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        onClose();
    };

    return (
        <>
            <Button variant="contained" color="primary" onClick={handleClickOpen} startIcon={<IconAdd />}>
                Add Activity
            </Button>
            {isClient ? (
                <CreateWorkOrderPage open={open} setOpen={setOpen} />
            ) : (
                <AddActivityDialog
                    open={open}
                    setOpen={setOpen}
                    vehicleId={vehicleId}
                    lotId={lotId}
                    clientId={clientId}
                    onClose={handleClose}
                    vehicleTypeId={vehicleTypeId}
                    entityId={entityId}
                    vehicleDetails={vehicleDetails}
                />
            )}
        </>
    );
};

export default AddActivity;